import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const LuxurySoftPlayPackages = () => {
  const packages = [{
    id: '01',
    name: 'Fancy Tot',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uU6ZBP89bA24T6gpbVzeEX/image.png',
    features: ['Medium White Bounce House w/ slide', 'White puzzles mat area (15x 12)', '3 Bouncy Animals', 'White Ball Pit (clear & white)', 'Gym Climbing Blocks', 'Crawling Tunnel', 'Safety Gates', '"My First Roller Coaster"'],
    price: '$400'
  }, {
    id: '02',
    name: 'Mega Fancy Tot',
    image: 'https://t3.ftcdn.net/jpg/02/77/69/26/360_F_277692690_xAGq27kZEjCmDq8D3lcttSjM6IeUVgKI.jpg',
    features: ['Your choice between two large white combo bounce houses', 'White Puzzle Mats (18ft x 12ft or 15ft x 15ft)', '5 Bouncy Animals', 'White Ball Pit (clear & white)', 'Gym Climbing Blocks', 'Crawling Tunnel', 'Safety Gates', 'Rocking Horse', '"My First Roller Coaster"'],
    price: '$450'
  }, {
    id: '03',
    name: 'Fancy Tot Customization Upgrades',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/goXZ8RzqHj1vHnv7UwdHh1/image.png',
    customizations: [{
      title: 'Standard Customizations - $25',
      items: ['Choose your ball colors', 'Choose your bouncy animal colors', 'Choose your mat color (blue, pink, or white)']
    }, {
      title: 'Vinyl Decals - $25 per decal',
      items: []
    }],
    price: null,
    isCustomization: true
  }];
  return <div className="bg-white w-full" data-id="element-502">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-503">
        {/* Page Title Section */}
        <div className="text-center mb-16" data-id="element-504">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-505">
            Luxury Soft Play Packages
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-506">
            Elegant white-themed soft play setups that add a sophisticated touch
            to any celebration.
          </p>
        </div>
        {/* Package Cards Section */}
        <div className="space-y-8" data-id="element-507">
          {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100" data-id="element-508">
              <div className="flex flex-col md:flex-row" data-id="element-509">
                {/* Package Image */}
                <div className="md:w-1/2 relative" data-id="element-510">
                  <img src={pkg.image} alt={`${pkg.name} Package`} className="w-full h-full object-cover" data-id="element-511" />
                  {pkg.id === '01' && <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white text-center py-2 text-sm" data-id="element-512">
                      Color customizations, as shown here, are available for an
                      additional fee. See details below.
                    </div>}
                </div>
                {/* Package Details */}
                <div className="p-8 md:w-1/2" data-id="element-513">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-514">
                    <span className="text-primary-500" data-id="element-515">{pkg.id}</span> -{' '}
                    {pkg.name}
                  </h2>
                  {pkg.isCustomization ? <>
                      <p className="text-gray-600 mb-6" data-id="element-516">
                        Personalize your Fancy Tot package with these
                        customization options:
                      </p>
                      <div className="space-y-4 mb-8" data-id="element-517">
                        {pkg.customizations.map((customization, idx) => <div key={idx} data-id="element-518">
                            <p className="font-bold text-gray-900 mb-2" data-id="element-519">
                              {customization.title}
                            </p>
                            {customization.items.length > 0 && <ul className="ml-6 space-y-1" data-id="element-520">
                                {customization.items.map((item, itemIdx) => <li key={itemIdx} className="text-gray-600 list-disc" data-id="element-521">
                                    {item}
                                  </li>)}
                              </ul>}
                          </div>)}
                      </div>
                    </> : <ul className="space-y-3 mb-8" data-id="element-522">
                      {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-523">
                          <CheckIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-524" />
                          <span data-id="element-525">{feature}</span>
                        </li>)}
                    </ul>}
                  {pkg.price && <div className="mt-auto text-center" data-id="element-526">
                      <span className="text-4xl font-bold text-green-800" data-id="element-527">
                        {pkg.price}
                      </span>
                    </div>}
                </div>
              </div>
            </div>)}
        </div>
        {/* Call to Action */}
        <div className="mt-16 text-center" data-id="element-528">
          <Link to="/contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-secondary-500 hover:bg-primary-600 transition" data-id="element-529">
            Book Your Play Experience
          </Link>
        </div>
      </div>
    </div>;
};